module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/window-maximize-5689381bc4cb559f98c48580ed3eb60d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/window-maximize.svg
// module id = gWO3
// module chunks = 24